import { useEffect, useRef, useState } from "react";
import { useAuth } from "../AuthContext";
import { apiFetch } from "../../../utils/api";

export const useArticleBrief = (id, auto) => {
  const { user, loading } = useAuth();
  const userId = user?.user_id, tier = user?.subscription_tier;
  const [data, setData] = useState(null), [error, setError] = useState(""), [locked, setLocked] = useState(false);
  const [action, setAction] = useState(0);
  const started = useRef(new Set());
  useEffect(() => {
    let active = true, timer;
    setData(null); setError(""); setLocked(false);
    if (loading) return;
    if (!userId) { setLocked(true); return; }
    const endpoint = `/api/search/articles/${id}/brief`;
    const failure = err => { if (active) { if ([401, 403].includes(err.status)) setLocked(true); else { setError("This article brief could not be loaded. Please retry."); setData(value => value?.status === "pending" ? { ...value, status: "failed" } : value); } } };
    const accept = result => {
      if (!active) return;
      setData(result.data);
      if (result.data.status === "pending") timer = setTimeout(() => apiFetch(endpoint).then(accept).catch(failure), 1800);
    };
    const key = `${id}:${userId}:${action}`;
    apiFetch(endpoint).then(result => {
      if (!active) return;
      accept(result);
      if ((auto || action > 0) && ["not_prepared", "failed"].includes(result.data.status) && !started.current.has(key)) {
        // Failed work only retries after an explicit button, never a saved-page visit.
        if (result.data.status === "failed" && action === 0) return;
        started.current.add(key); setData(value => ({ ...value, status: "pending" }));
        apiFetch(endpoint, { method: "POST" }).then(accept).catch(failure);
      }
    }).catch(failure);
    return () => { active = false; clearTimeout(timer); };
  }, [id, auto, action, loading, userId, tier]);
  return { data, error, locked, busy: data?.status === "pending", prepare: () => setAction(value => value + 1), selectEdition: () => {} };
};